export function search(state){
    return state.search
}

export function selected_areas(state){
    return state.selected_areas
}

export function selected_tags(state){
    return state.selected_tags
}